/**
 * Enum for file type
 */
export enum FileType {
  FileSystem = 0,
  Cloud_GSB = 1,
  Cloud_Azure = 2,
  Cloud_AWS = 3,
  Cloud_Google = 4
}

/**
 * Enum for listing type
 */
export enum ListingType {
  Folder = 1,
  File = 2
}

/**
 * Represents a chunk info for file
 */
export class ChunkInfo {
  _entDefName?: string;
  files?: GsbFile[];
  totalSize?: number; // Total size in bytes

  constructor(obj?: Partial<ChunkInfo>) {
      Object.assign(this, obj);
      this._entDefName = "ChunkInfo";
  }
}

/**
 * Represents a split files result
 */
export class SplitFilesResult {
  _entDefName?: string;
  totalSize?: number; // Total size of all files in bytes
  chunks?: ChunkInfo[];

  constructor(obj?: Partial<SplitFilesResult>) {
      Object.assign(this, obj);
      this._entDefName = "SplitFilesResult";
  }
}

/**
 * Represents a GSB File entity
 */
export class GsbFile {
  _entDefName?: string;
  id?: string;
  name?: string;
  path?: string;
  properties?: string;
  fileType?: FileType;
  listingType?: ListingType;
  versionMajor?: number;
  versionMinor?: number;
  buildNumber?: number;
  contentType?: string;
  icon?: string;
  parent?: GsbFile;
  parent_id?: string;
  children?: GsbFile[];
  publicUrl?: string;
  size?: number;
  fileToUpload?: File;
  editPermission_id?: string;
  readPermission_id?: string;
  deletePermission_id?: string;
  createDate?: Date;
  lastUpdateDate?: Date;
  createdBy_id?: string;
  lastUpdatedBy_id?: string;
  title?: string;

  constructor(obj?: Partial<GsbFile>) {
      Object.assign(this, obj);
      this._entDefName = "GsbFile";
  }
}
